module.exports = __webpack_public_path__ + "img/0Q3A5801_L_BlackMatted_MockedUp.7e5db30c.jpg";